import React, { Component } from 'react';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';
import { HexAlphaColorPicker, HexColorInput } from 'react-colorful';
import getFonts from '../../../Functions/config/fonts';
import getSelectField from '../../fields/select';
import toggleColorPicker from '../../../Functions/toggleColorPicker';

class ButtonSettings extends Component {
    constructor(props) {
        super(props);
    }

    renderIncrementalSetting = (label, value, name, step = 1, min = 0) => {
        let displayValue = value;
        let unit = 'px';

        if (typeof value === 'string') {
            const match = value.match(/^([\d.]+)(.*)$/);
            if (match) {
                displayValue = match[1];
                unit = match[2] || 'px';
            }
        }

        return (
            <div className='mjwi-row'>
                <div className='mjwi-col50'>
                    <label>{label}</label>
                </div>
                <div className='mjwi-col50'>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                            type="number"
                            name={name}
                            value={displayValue || ''}
                            onChange={(e) => {
                                const val = e.target.value;
                                this.props.handleInputChange(
                                    { target: { name, value: val ? `${parseFloat(val) || min}${unit}` : `${min}${unit}` } },
                                    ['button']
                                );
                            }}
                            className="mjwi-input"
                            min={min}
                            step={step}
                            style={{ flexGrow: 1 }}
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderColorPicker = (label, color, field) => (
        <div className="mjwi-row">
            <div className="mjwi-col50">
                <label>{label}</label>
            </div>
            <div className="mjwi-col50 mjwi-clr-picker">
                <span
                    className="clrPickerVal"
                    onClick={toggleColorPicker}
                    style={{ backgroundColor: color }}
                ></span>
                <HexAlphaColorPicker
                    color={color}
                    onChange={(newColor) => this.props.setColorsAndPreview('button', field, newColor)}
                    className="mjwi-apfl-color-picker"
                    style={{ display: 'none' }}
                />
                <HexColorInput
                    color={color}
                    onChange={(newColor) => this.props.setColorsAndPreview('button', field, newColor)}
                    className="mjwi-color-input"
                />
            </div>
        </div>
    );

    renderDropdown = (label, name, value, options) => (
        <div className="mjwi-row">
            <div className="mjwi-col50">
                <label>{label}</label>
            </div>
            <div className="mjwi-col50">
                {getSelectField(name, options.map(opt => opt.label), value, (e) => this.props.handleInputChange(e, ['button']))}
            </div>
        </div>
    );

    renderButtonSettings = () => {
        const { tripadvisor } = this.props;
        const fontFamilyOptions = getFonts().map(font => ({ value: font, label: font }));
        const alignmentOptions = [
            { value: 'left', label: 'Left' },
            { value: 'center', label: 'Center' },
            { value: 'right', label: 'Right' }
        ];
        const fontWeightOptions = [
            { value: 'normal', label: 'Normal' },
            { value: 'bold', label: 'Bold' },
            { value: '100', label: '100' },
            { value: '200', label: '200' },
            { value: '300', label: '300' },
            { value: '400', label: '400' },
            { value: '500', label: '500' },
            { value: '600', label: '600' },
            { value: '700', label: '700' },
            { value: '800', label: '800' },
            { value: '900', label: '900' }
        ];

        return (
            <Accordion allowZeroExpanded={true}>
                <AccordionItem className='mjwi-sub-accordion'>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            Write a Review
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        <div className='mjwi-acc-panel-wrapper'>
                            {this.renderColorPicker('Text Color', tripadvisor.button.WriteReviewColor, 'WriteReviewColor')}
                            {this.renderColorPicker('Background Color', tripadvisor.button.WriteReviewBackgroundColor, 'WriteReviewBackgroundColor')}
                            {this.renderColorPicker('Hover Text Color', tripadvisor.button.WriteReviewHoverTextColor, 'WriteReviewHoverTextColor')}
                            {this.renderColorPicker('Hover Background Color', tripadvisor.button.WriteReviewHoverBackgroundColor, 'WriteReviewHoverBackgroundColor')}
                            {this.renderDropdown('Alignment', 'button.WriteReviewAlignment', tripadvisor.button.WriteReviewAlignment, alignmentOptions)}
                            {this.renderDropdown('Font Family', 'button.WriteReviewFontFamily', tripadvisor.button.WriteReviewFontFamily, fontFamilyOptions)}
                            {this.renderDropdown('Font Weight', 'button.WriteReviewFontWeight', tripadvisor.button.WriteReviewFontWeight, fontWeightOptions)}
                            {this.renderIncrementalSetting('Font Size', tripadvisor.button.WriteReviewFontSize, 'button.WriteReviewFontSize', 1)}
                            {this.renderIncrementalSetting('Padding', tripadvisor.button.WriteReviewPadding, 'button.WriteReviewPadding', 1)}
                            {this.renderIncrementalSetting('Border Radius', tripadvisor.button.WriteReviewBorderRadius, 'button.WriteReviewBorderRadius', 1)}
                        </div>
                    </AccordionItemPanel>
                </AccordionItem>
            </Accordion>
        );
    };

    render() {
        return this.props.renderSection('Button', this.renderButtonSettings(), 'button-settings');
    }
}

export default ButtonSettings;